import 'jquery-match-height/dist/jquery.matchHeight-min';
import Swiper from 'swiper';
import { add_swiper_class, swiper_destroy } from '@corbieres/js/tools/swiper';
import Utils from '@corbieres/js/services/utils';

export default class WpetList {
    
    constructor()
    {
        WpetList.view_mode();
        WpetList.slider();
        WpetList.match_height();
        WpetList.filters();
        WpetList.link_offer();
        WpetList.offer_meta_mobile();
        WpetList.initialize_trigger();
        WpetList.bind_wpet_datepicker();
        WpetList.kml_list();
    }
    
    static view_mode()
    {
        const trigger  = '[data-trigger="wpet-mode"]',
              $element = $( '[data-id="wpet-list"]' );
        
        if ( trigger.length > 0 ) {
            $( document ).on( 'click', trigger, function ( e ) {
                e.preventDefault();
                const mode = $( this ).attr( 'data-wpet-switch-mode' );
                $element.attr( 'data-wpet-current-mode', mode );
                window.wpet_map_object.mapObject.resize();
                $( 'html, body' ).animate( {
                                               scrollTop: $element.offset().top
                                           }, 500 );
                
                $( document ).trigger( 'wpet_change_mode' );
            } );
        }
    }
    
    static number_results( data )
    {
        const $element = $( '[data-id="wpet-list-total-offer"]' );
        $element.text( data.total_global );
    }
    
    static number_current_engine()
    {
        const filters_total = $( '[data-filters-total]' ).data( 'filters-total' ),
              $element      = $( '[data-id="wpet-list-total-current-engine"]' );
        
        if ( filters_total > 0 ) {
            $element.text( '(' + filters_total + ')' );
        } else {
            $element.text( '' );
        }
    }
    
    static slider()
    {
        const slider         = '[data-id="wpet-offer-slider"]',
              slider_wrapper = '[data-id="wpet-offer-slider-wrapper"]',
              slider_item    = '[data-id="wpet-offer-slider-item"]';
        
        let swiper_offer;
        
        if ( $( slider ).length > 0 ) {
            
            $( slider ).each( function () {
                
                let slider_elements = $( this ).find( slider_item );
                
                if ( $( slider_elements ).length > 1 ) {
                    
                    add_swiper_class( $( this ), $( this ).find( slider_wrapper ), $( this ).find( slider_item ) );
                    
                    swiper_offer = new Swiper( $( this ), {
                        mousewheel: {
                            forceToAxis: true,
                            preventClicks: false,
                        },
                        lazy: true,
                        navigation: {
                            nextEl: '[data-trigger="swiper-next"]',
                            prevEl: '[data-trigger="swiper-prev"]',
                        },
                    } );
                }
            } );
        }
    }
    
    static match_height()
    {
        const $element = $( '[data-mh]' );
        
        if ( $element.length > 0 ) {
            $element.matchHeight();
        }
    }
    
    static filters()
    {
        let trigger  = '[data-trigger="wpet-list-filters-button"]',
            close    = '[data-trigger="wpet-list-results-filters-list-close"]',
            $element = $( 'body' );
        
        $( document ).on( 'click', trigger, function ( e ) {
            e.preventDefault();
            $element.addClass( 'isWpetFiltersOpen' );
        } );
        
        $( document ).on( 'click', close, function ( e ) {
            e.preventDefault();
            $element.removeClass( 'isWpetFiltersOpen' );
        } );
        
        $( document ).on( 'wpet_ajax_build', function () {
            $element.removeClass( 'isWpetFiltersOpen' );
        } );
    }
    
    static link_offer()
    {
        const trigger = '[data-trigger="wpet-click"]';
        
        if ( trigger.length > 0 ) {
            $( document ).on( 'click', trigger, ( e ) => {
                if ( !$( e.target ).hasClass( 'slider-arrow' ) ) {
                    e.preventDefault();
                    window.open( $( e.currentTarget ).parents( '[data-id="wpet-offer"]' ).find( '[data-id="wpet-offer-link"]' ).attr( 'href' ), '_blank' );
                }
            } );
        }
    }
    
    static offer_meta_mobile()
    {
        const trigger = '[data-trigger="wpet-offer-mobile-button"]',
              element = '[data-id="wpet-offer-mobile-list"]';
        
        $( document ).on( 'click', trigger, function ( e ) {
            e.preventDefault();
            $( this ).parents( '[data-id="wpet-offer"]' ).find( element ).toggle();
        } );
    }
    
    static form_select()
    {
        $( 'select' ).parent().not( '.formSelect' ).children( 'select' ).wrap( '<div class="formSelect"></div>' );
    }
    
    static back_to_top()
    {
        $( 'html, body' ).animate( {
                                       scrollTop: $( '[data-id="wpet-list"]' ).offset().top
                                   }, 300 );
    }
    
    static initialize_trigger()
    {
        $( document ).on( 'wpet_ajax_build', ( e, data ) => {
            WpetList.form_select();
            WpetList.slider();
            Utils.lazy();
            WpetList.match_height();
            WpetList.back_to_top();
            WpetList.number_results( data );
            WpetList.number_current_engine();
        } );
        
        $( document ).on( 'wpet_ajax_build wpet_ajax_only_form', () => {
            WpetList.form_select();
        } );
        
        $( document ).on( 'wpet_ajax_navigation', () => {
            WpetList.slider();
            WpetList.match_height();
            Utils.lazy();
        } );
        
        $( document ).on( 'wpet_change_mode', () => {
            swiper_destroy( '[data-id="wpet-offer-slider"]' );
            WpetList.slider();
            WpetList.match_height();
        } );
        
    }
    
    static bind_wpet_datepicker()
    {
        
        $( '.wpet_datepicker, .marketplace_startdate .picker__input' ).each( function ( index, el ) {
            
            let $that = $( this );

            console.log($that);
            
            setTimeout( function () {
                
                let $wpet_datepicker = $that.pickadate( 'picker' );
                
                if ( $wpet_datepicker !== undefined ) {
                    
                    $wpet_datepicker.on( 'open', function ( e ) {
                        $( 'body' ).addClass( 'isWpetDatepickerActive' );
                    } );
                    
                    $wpet_datepicker.on( 'close', function ( e ) {
                        $( 'body' ).removeClass( 'isWpetDatepickerActive' );
                    } );
                }
                
            }, 0 );
        } );
    }
    
    /* KML list
     /* ============================================= */
    static kml_list()
    {
        let current_gpx = null;
        
        const trigger = '[data-trigger="wpet-show-trace"]';
        
        $( document ).on( 'click', trigger, function ( e ) {
            e.preventDefault();
            
            if ( $( '.wpetList[data-wpet-current-mode="mixte"]' ).length > 0 ) {
                
                if ( current_gpx !== null ) {
                    window.wpet_map_object.mapObject.resetKmlGpx( current_gpx );
                }
                
                let gpx_url = $( this ).data( 'gpx' );
                
                if ( gpx_url != '' && gpx_url != undefined && gpx_url != null ) {
                    
                    //url kml
                    let url = gpx_url;
                    
                    current_gpx = gpx_url;
                    
                    //est ce que l'on recentre la carte avec le kml ou non
                    let recenter = true;
                    
                    //style du kml
                    let style = {
                        strokeColor: '#B3045C',
                        weight: 3
                    };
    
                    window.wpet_map_object.mapObject.bounds = new window.wpet_map_object.mapAdapter.Bounds();
                    window.wpet_map_object.mapObject.addKmlGpx( url, style, recenter );
                    
                } else {
                    window.wpet_map_object.mapObject.fitBounds( wpet_map_object.bounds );
                }
                
            }
        } );
    }
};
